const TimeAnalysisSkeleton = () => {
  return (
    <div className="overflow-x-auto mt-4">
      <div className="min-w-[700px] border-r border-l border-[var(--q3-stroke-light)] rounded-b-lg overflow-hidden">
        {Array.from({ length: 8 }).map((_, rowIndex) => (
          <div
            key={rowIndex}
            className="grid grid-cols-4 divide-x divide-[var(--q3-stroke-light)] border-t border-[var(--q3-stroke-light)]"
          >
            {[...Array(4)].map((_, colIndex) => (
              <div key={colIndex} className="p-4 flex gap-2 justify-center items-center">
                <div className="h-3 w-full max-w-[80px] bg-gray-300 rounded-full" />
                <div className="h-3 w-full max-w-[80px] bg-gray-300 rounded-full" />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TimeAnalysisSkeleton;
